import { render, staticRenderFns } from "./ToolboxTalks.vue?vue&type=template&id=7272016f&"
import script from "./ToolboxTalks.vue?vue&type=script&lang=js&"
export * from "./ToolboxTalks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports